export default (props) => {
  return (<>
    {props.error && <div className='text-danger mt-2'>
      {(typeof props.error) == "string" && props.error}
      {Array.isArray(props.error) && props.error.map((item) => <>
        <p>{item}</p>
      </>)}
    </div>}
  </>);
}